import { render } from "./PageWasNotFound.vue?vue&type=template&id=5c388834"
import script from "./PageWasNotFound.vue?vue&type=script&lang=js"
export * from "./PageWasNotFound.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\apps\\appKonferenceStudioW\\v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__